'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  PAGE_TEMPLATES: null,
  SYSTEM_PAGE_TEMPLATES: null,
  TEMPLATES: null
});